import type { ContentfulNavQuickLinkFragment } from '@/graphql/contentful/api';
import { useRouter } from '@/hooks/useRouter';
import { containsPattern } from '@/lib/util';

import { useHandleQuickLink } from '../NavQuickLinkItem/helpers';

import * as S from './NavQuickLinkBannerItem.styles';
export interface NavQuickLinkProps extends ContentfulNavQuickLinkFragment {
  className?: string;
}

export const NavQuickLinkBannerItem = ({
  className,
  url,
  urlTarget,
  urlText,
  urlTrigger,
}: NavQuickLinkProps) => {
  const { asPath, query } = useRouter();
  const { handleQuickLink } = useHandleQuickLink(
    url ?? '/',
    urlTarget ?? '_self',
    urlTrigger,
  );
  const isContains = containsPattern(asPath, url);
  const active =
    query.slug?.includes(url ?? '') ||
    asPath?.includes(url ?? '') ||
    isContains;
  return (
    <S.Wrapper
      $isActive={active ?? false}
      className={className}
      data-test-id='NavQuickLinkBannerItemWrapper'
      onClick={handleQuickLink}
    >
      {urlText}
    </S.Wrapper>
  );
};
